<ng-container *ngIf="isOpen">

  <!-- Overlay. Dismissing by clicking away must not count as accepting the terms. -->
  <div #modalOverlay
    (click)="onCancel()"
    class="fixed inset-0 bg-black/60 z-[9998]">
  </div>

  <!-- Viewport Center Wrapper -->
  <div #modalWrapper class="fixed z-[9999] install-modal-wrapper" style="top:0;left:0;right:0;bottom:0;display:flex;align-items:center;justify-content:center;padding:1rem;">

    <!-- Modal -->
    <div
      class="w-full bg-white border-2 border-[#94272C] rounded-lg sm:rounded-xl shadow-2xl flex flex-col install-modal-box"
      style="font-family:sans-serif;max-width:min(95vw,800px);max-height:75vh;">

      <!-- Scrollable Content -->
      <div class="overflow-y-auto flex-1 px-4 sm:px-8 md:px-10 py-4 sm:py-6 md:py-8 space-y-4 sm:space-y-5 text-gray-800 leading-relaxed text-[12px] sm:text-[13px] md:text-sm">

        <div>
          <p class="font-bold text-gray-900 mb-1 text-[13px] sm:text-sm md:text-base">Wall Preparation Responsibility:</p>
          <p>
            Customers are responsible for ensuring the walls are fully prepared (smooth, primed, and finished) before installation.
          </p>
          <p class="mt-1">
            In case of installation failure due to improper wall preparation, a failure charge of
            <span class="font-bold">₹800/-</span> will be applicable.
          </p>
        </div>

        <div>
          <p class="font-bold text-gray-900 mb-1 text-[13px] sm:text-sm md:text-base">Customer Availability:</p>
          <p>
            The customer or their representative must be available at the site during installation.
            Failure to provide access may result in rescheduling charges.
          </p>
        </div>

        <div>
          <p class="font-bold text-gray-900 mb-1 text-[13px] sm:text-sm md:text-base">Failure Charges:</p>
          <p>
            If the installation cannot proceed due to wall preparation issues or customer unavailability,
            the customer will be liable to pay the installation failure charge of
            <span class="font-bold">₹800/-</span>.
          </p>
        </div>

        <div>
          <p class="font-bold text-gray-900 mb-1 text-[13px] sm:text-sm md:text-base">Acceptance of Terms:</p>
          <p>
            Customers must accept these Terms and Conditions before placing an installation request.
          </p>
        </div>

        <div>
          <p class="font-bold text-gray-900 mb-1 text-[13px] sm:text-sm md:text-base">Dynamic Updates:</p>
          <p>
            Terms and Conditions are subject to change. Customers are advised to review the latest version
            on our website before proceeding.
          </p>
        </div>

      </div>

      <!-- Footer -->
      <div class="border-t border-gray-200 p-3 sm:p-4 flex flex-col sm:flex-row justify-center items-stretch sm:items-center gap-2 sm:gap-3 bg-white shrink-0">
        <button
          (click)="onCancel()"
          class="w-full sm:w-auto bg-white border border-gray-300 text-gray-700 hover:border-gray-500 hover:text-gray-900 font-bold uppercase tracking-[0.2em] text-xs sm:text-sm px-6 sm:px-10 py-2.5 sm:py-3 rounded-md transition-all">
          Cancel
        </button>
        <button
          (click)="onAgree()"
          class="w-full sm:w-auto bg-[#600b0b] hover:bg-[#8c1c1c] text-white font-bold uppercase tracking-[0.2em] text-xs sm:text-sm px-6 sm:px-10 py-2.5 sm:py-3 rounded-md shadow-lg transition-all">
          Agree
        </button>
      </div>

    </div>
  </div>

</ng-container>
